(() => {
  'use strict';

  const SELECTORS = {
    header: 'header',
    hamburger: '.u_hamberger',
    mobileMenu: '.u_mobile_menu',
    mobileMenuOverlay: '.u_mb_menu_overlay',
    mobileMenuList: '.u_nav_ul_mb',
    firstDisclosure: '.u_menu__link, .u_ficon_mb',
    secondDisclosure: '.u_menu__dlink, .u_sicon_mb',
    firstDropdown: '.u_sec_dropdown_mb',
    secondDropdown: '.u_third_dropdown_mb',
    quickAction: '.block-quick-search, .bls-minicart-action',
    cartOverlay: '.u_cart_overlay',
    collectionSidebar: '.collection-sidebar',
    collectionBack: '.collection-category-back-link[data-action="show-full-menu"]',
    mobileNavigationRoot: '[data-hob-mobile-navigation]',
    mobileNavigationData: '[data-hob-mobile-navigation-data]',
    mobileNavigationList: '[data-hob-navigation-list]'
  };

  const MOBILE_NAVIGATION_ICONS = Object.freeze({
    disclosure:
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" width="12" height="19"><path d="M143 352.3L7 216.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.2 9.4-24.4 9.4-33.8 0z"></path></svg>',
    arrow:
      '<svg viewBox="0 0 300 300" height="18" width="18"><g transform="matrix(16.978,0,0,16.978,14.1681,14.1756)"><path style="fill:rgb(182, 182, 182)" d="M1,8C1,7.726 1.226,7.5 1.5,7.5L13.293,7.5L10.146,4.354C10.052,4.26 9.999,4.133 9.999,4C9.999,3.725 10.225,3.499 10.5,3.499C10.633,3.499 10.76,3.552 10.854,3.646L14.854,7.646C14.948,7.74 15.001,7.867 15.001,8C15.001,8.133 14.948,8.26 14.854,8.354L10.854,12.354C10.76,12.448 10.633,12.501 10.5,12.501C10.225,12.501 9.999,12.275 9.999,12C9.999,11.867 10.052,11.74 10.146,11.646L13.293,8.5L1.5,8.5C1.226,8.5 1,8.274 1,8"></path></g></svg>',
    arrowActive:
      '<svg viewBox="0 0 300 300" height="18" width="18"><g transform="matrix(16.9779,0,0,16.9779,14.1682,14.1767)"><path style="fill:rgb(255, 255, 255)" d="M1,8C1,7.726 1.226,7.5 1.5,7.5L13.293,7.5L10.146,4.354C10.052,4.26 9.999,4.133 9.999,4C9.999,3.725 10.225,3.499 10.5,3.499C10.633,3.499 10.76,3.552 10.854,3.646L14.854,7.646C14.948,7.74 15.001,7.867 15.001,8C15.001,8.133 14.948,8.26 14.854,8.354L10.854,12.354C10.76,12.448 10.633,12.501 10.5,12.501C10.225,12.501 9.999,12.275 9.999,12C9.999,11.867 10.052,11.74 10.146,11.646L13.293,8.5L1.5,8.5C1.226,8.5 1,8.274 1,8"></path></g></svg>',
    info:
      '<svg viewBox="0 0 300 300" height="18" width="18"><g transform="matrix(14.8567,0,0,14.8567,31.1461,31.1461)"><path style="fill-rule:nonzero" d="M8,0C12.389,0 16,3.611 16,8C16,12.389 12.389,16 8,16C3.611,16 0,12.389 0,8C0,3.611 3.611,0 8,0M4.5,7.5C4.226,7.5 4,7.726 4,8C4,8.274 4.226,8.5 4.5,8.5L10.293,8.5L8.146,10.646C8.052,10.74 7.999,10.867 7.999,11C7.999,11.275 8.225,11.501 8.5,11.501C8.633,11.501 8.76,11.448 8.854,11.354L11.854,8.354C11.948,8.26 12.001,8.133 12.001,8C12.001,7.867 11.948,7.74 11.854,7.646L8.854,4.646C8.76,4.552 8.633,4.499 8.5,4.499C8.225,4.499 7.999,4.725 7.999,5C7.999,5.133 8.052,5.26 8.146,5.354L10.293,7.5L4.5,7.5Z"></path></g></svg>'
  });

  const animationTimers = new WeakMap();
  const animatedElements = new Set();
  const openHeaders = new Set();
  const removers = [];
  let mounted = false;
  let generatedId = 0;
  let ownsOverflowClass = false;

  function elementsWithin(scope, selector) {
    if (!scope) return [];
    const elements = [];
    if (scope.nodeType === Node.ELEMENT_NODE && scope.matches(selector)) {
      elements.push(scope);
    }
    if (typeof scope.querySelectorAll === 'function') {
      elements.push(...scope.querySelectorAll(selector));
    }
    return elements;
  }

  function ensureId(element, prefix) {
    if (element.id) return element.id;
    generatedId += 1;
    element.id = `${prefix}-${generatedId}`;
    return element.id;
  }

  function element(tagName, className) {
    const node = document.createElement(tagName);
    if (className) node.className = className;
    return node;
  }

  function staticIcon(markup) {
    const template = document.createElement('template');
    template.innerHTML = markup;
    return template.content.firstElementChild;
  }

  function appendArrowPair(link) {
    const arrow = element('div', 'u_menu1_arrow');
    arrow.append(staticIcon(MOBILE_NAVIGATION_ICONS.arrow));
    const activeArrow = element('div', 'u_menu1_arrow_active');
    activeArrow.append(staticIcon(MOBILE_NAVIGATION_ICONS.arrowActive));
    link.append(arrow, activeArrow);
  }

  function appendDisclosureIcon(row, level) {
    const wrapper = element(level === 1 ? 'span' : 'div', level === 1 ? 'u_ficon_mb' : 'u_sicon_mb');
    const icon = element('i', 'fas fa-angle-down');
    icon.append(staticIcon(MOBILE_NAVIGATION_ICONS.disclosure));
    wrapper.append(icon);
    row.append(wrapper);
  }

  function createThirdLevel(items, variant) {
    const list = element('ul', 'u_third_dropdown_mb');
    items.forEach((item, index) => {
      const listItem = element('li', 'u_dropdown_list_mb_level');
      const link = element(
        'a',
        'u_navbar_item_link_mb_3level' +
          (variant === 'categories' && index === 0 ? ' u_active_smenu' : '')
      );
      link.href = item.u;
      link.textContent = item.t;
      if (variant === 'categories') {
        link.setAttribute('levels', '0');
        if (index === 0) appendArrowPair(link);
      }
      listItem.append(link);
      list.append(listItem);
    });
    return list;
  }

  function createSecondLevel(items, variant) {
    const list = element('ul', 'u_sec_dropdown_mb');
    items.forEach((item, index) => {
      const children = Array.isArray(item.c) ? item.c : [];
      const listItem = element('li', 'u_dropdown_list_mb_level');
      const row = element('div', 'u_dropdown_list_mb_inner');
      const classes = ['u_navbar_item_link_mb_level'];
      if (variant === 'categories' && index === 0) classes.push('u_active_smenu');
      if (children.length) classes.push('u_menu__dlink');
      const link = element('a', classes.join(' '));
      link.href = children.length ? '#' : item.u;
      link.textContent = item.t;
      if (variant === 'categories') {
        link.setAttribute('levels', String(children.length));
        if (index === 0) appendArrowPair(link);
      }
      row.append(link);
      if (children.length) appendDisclosureIcon(row, 2);
      listItem.append(row);
      if (children.length) listItem.append(createThirdLevel(children, variant));
      list.append(listItem);
    });
    return list;
  }

  function createNavigationList(items, variant) {
    const list = element('ul', 'u_dropdown_mb');
    items.forEach((item) => {
      const children = Array.isArray(item.c) ? item.c : [];
      const listItem = element('li', 'u_dropdown_list_mb');
      const row = element('div', 'u_dropdown_list_mb_inner');
      const link = element(
        'a',
        'u_navbar_item_link_mb' + (children.length ? ' u_menu__link' : '')
      );
      link.href = children.length ? '#' : item.u;
      link.append(document.createTextNode(item.t));
      if (/Sale|SALE|Aanbieding|Korting/.test(item.t)) {
        const sale = element('span', 'u_menu_sale_icon');
        sale.textContent = '%';
        link.append(document.createTextNode(' '), sale);
      }
      if (variant === 'info' && !children.length) {
        link.append(document.createTextNode(' '), staticIcon(MOBILE_NAVIGATION_ICONS.info));
      }
      row.append(link);
      if (children.length) appendDisclosureIcon(row, 1);
      listItem.append(row);
      if (children.length) listItem.append(createSecondLevel(children, variant));
      list.append(listItem);
    });
    return list;
  }

  function prepareDisclosures(scope) {
    elementsWithin(scope, SELECTORS.firstDisclosure).forEach((trigger) => {
      const { item, dropdown } = disclosureParts(trigger, 1);
      prepareDisclosure(item, dropdown, 1);
    });
    elementsWithin(scope, SELECTORS.secondDisclosure).forEach((trigger) => {
      const { item, dropdown } = disclosureParts(trigger, 2);
      prepareDisclosure(item, dropdown, 2);
    });
  }

  function hydrateMobileNavigation(menu) {
    const root = menu?.querySelector(SELECTORS.mobileNavigationRoot);
    if (!root || root.dataset.hobNavigationReady === 'true') return true;
    const dataNode = root.querySelector(SELECTORS.mobileNavigationData);
    if (!dataNode) return false;

    try {
      const data = JSON.parse(dataNode.textContent);
      root.querySelectorAll(SELECTORS.mobileNavigationList).forEach((target) => {
        const variant = target.dataset.hobNavigationList;
        const items = Array.isArray(data[variant]) ? data[variant] : [];
        target.replaceChildren(createNavigationList(items, variant));
      });
      root.dataset.hobNavigationReady = 'true';
      dataNode.remove();
      prepareDisclosures(root);
      return true;
    } catch (error) {
      console.error('Unable to hydrate mobile navigation', error);
      return false;
    }
  }

  function directChild(parent, selector) {
    if (!parent) return null;
    try {
      const scopedSelector = selector
        .split(',')
        .map((part) => `:scope > ${part.trim()}`)
        .join(', ');
      return parent.querySelector(scopedSelector) || parent.querySelector(selector);
    } catch (_error) {
      return parent.querySelector(selector);
    }
  }

  function disclosureParts(trigger, level) {
    if (level === 1) {
      const item = trigger.closest('.u_dropdown_list_mb, .collection-category-item');
      return {
        item,
        dropdown: directChild(item, SELECTORS.firstDropdown)
      };
    }

    const item = trigger.closest('.u_dropdown_list_mb_level, .collection-category-level2');
    return {
      item,
      dropdown: directChild(item, SELECTORS.secondDropdown)
    };
  }

  function disclosureTriggers(item, level) {
    if (!item) return [];
    const row = directChild(item, '.u_dropdown_list_mb_inner, .collection-category-inner') || item;
    const selector = level === 1 ? SELECTORS.firstDisclosure : SELECTORS.secondDisclosure;
    return elementsWithin(row, selector);
  }

  function disclosureIsOpen(dropdown) {
    if (!dropdown) return false;
    const ariaHidden = dropdown.getAttribute('aria-hidden');
    if (ariaHidden === 'false') return true;
    if (ariaHidden === 'true') return false;
    return window.getComputedStyle(dropdown).display !== 'none';
  }

  function setDisclosureState(item, dropdown, level, open) {
    const dropdownId = ensureId(dropdown, 'hob-navigation-panel');
    disclosureTriggers(item, level).forEach((trigger) => {
      trigger.setAttribute('aria-controls', dropdownId);
      trigger.setAttribute('aria-expanded', String(open));
    });
    dropdown.setAttribute('aria-hidden', String(!open));

    const row = directChild(item, '.u_dropdown_list_mb_inner, .collection-category-inner') || item;
    const icon = row.querySelector('i');
    if (icon) {
      icon.classList.toggle('fa-angle-up', open);
      icon.classList.toggle('fa-angle-down', !open);
    }
  }

  function clearAnimation(dropdown) {
    const timers = animationTimers.get(dropdown);
    if (!timers) return;
    timers.forEach((timer) => window.clearTimeout(timer));
    animationTimers.delete(dropdown);
    animatedElements.delete(dropdown);
  }

  function finishAnimation(dropdown, open) {
    dropdown.style.display = open ? 'block' : 'none';
    dropdown.style.height = '';
    dropdown.style.overflow = '';
    dropdown.style.transition = '';
    animationTimers.delete(dropdown);
    animatedElements.delete(dropdown);
  }

  function animateDisclosure(dropdown, open, duration = 300) {
    clearAnimation(dropdown);

    if (open) {
      dropdown.style.display = 'block';
      const height = dropdown.scrollHeight;
      dropdown.style.height = '0px';
      dropdown.style.overflow = 'hidden';
      dropdown.style.transition = `height ${duration}ms ease`;
      const startTimer = window.setTimeout(() => {
        dropdown.style.height = `${height}px`;
      }, 10);
      const endTimer = window.setTimeout(() => finishAnimation(dropdown, true), duration);
      animationTimers.set(dropdown, [startTimer, endTimer]);
    } else {
      dropdown.style.display = 'block';
      dropdown.style.height = `${dropdown.scrollHeight}px`;
      dropdown.style.overflow = 'hidden';
      dropdown.style.transition = `height ${duration}ms ease`;
      const startTimer = window.setTimeout(() => {
        dropdown.style.height = '0px';
      }, 10);
      const endTimer = window.setTimeout(() => finishAnimation(dropdown, false), duration);
      animationTimers.set(dropdown, [startTimer, endTimer]);
    }

    animatedElements.add(dropdown);
  }

  function prepareDisclosure(item, dropdown, level) {
    if (!item || !dropdown) return;
    const open = window.getComputedStyle(dropdown).display !== 'none';
    setDisclosureState(item, dropdown, level, open);
    disclosureTriggers(item, level).forEach((trigger) => {
      if (!trigger.matches('a, button')) {
        trigger.setAttribute('role', 'button');
        trigger.setAttribute('tabindex', '0');
      }
    });
  }

  function toggleFirstActiveLink(dropdown) {
    const firstLink = dropdown?.querySelector(
      '.u_dropdown_list_mb_level:first-child .u_navbar_item_link_mb_level'
    );
    firstLink?.classList.toggle('u_active_smenu');
  }

  function toggleDisclosure(trigger, level) {
    const { item, dropdown } = disclosureParts(trigger, level);
    if (!item || !dropdown) return false;

    const open = !disclosureIsOpen(dropdown);
    if (level === 2) {
      toggleFirstActiveLink(trigger.closest(SELECTORS.firstDropdown));
      const activeLink = directChild(
        directChild(item, '.u_dropdown_list_mb_inner, .collection-category-inner') || item,
        '.u_menu__dlink, .u_navbar_item_link_mb_level'
      );
      activeLink?.classList.toggle('u_active_smenu');
    }

    setDisclosureState(item, dropdown, level, open);
    animateDisclosure(dropdown, open);
    return true;
  }

  function mobileMenuParts(header) {
    if (!header) return {};
    return {
      hamburger: header.querySelector(SELECTORS.hamburger),
      menu: header.querySelector(SELECTORS.mobileMenu),
      overlay: header.querySelector(SELECTORS.mobileMenuOverlay),
      list: header.querySelector(SELECTORS.mobileMenuList)
    };
  }

  function syncScrollLock() {
    const root = document.documentElement;
    if (openHeaders.size) {
      if (!root.classList.contains('overflow')) {
        root.classList.add('overflow');
        ownsOverflowClass = true;
      }
      return;
    }

    if (ownsOverflowClass) root.classList.remove('overflow');
    ownsOverflowClass = false;
  }

  function setMobileMenuOpen(header, open) {
    const { hamburger, menu, overlay, list } = mobileMenuParts(header);
    if (!menu) return false;
    if (open && !hydrateMobileNavigation(menu)) return false;

    hamburger?.classList.toggle('change', open);
    hamburger?.setAttribute('aria-expanded', String(open));
    menu.classList.toggle('active', open);
    menu.setAttribute('aria-hidden', String(!open));
    menu.inert = !open;

    if (overlay) {
      overlay.style.display = open ? 'block' : 'none';
      overlay.setAttribute('aria-hidden', String(!open));
    }
    if (list) list.style.display = open ? 'block' : 'none';

    if (open) openHeaders.add(header);
    else openHeaders.delete(header);
    syncScrollLock();
    return true;
  }

  function closeAllMobileMenus({ restoreFocus = false } = {}) {
    let focusTarget = null;
    const headers = new Set([...openHeaders, ...document.querySelectorAll(SELECTORS.header)]);
    headers.forEach((header) => {
      const { hamburger, menu } = mobileMenuParts(header);
      if (!menu?.classList.contains('active') && !openHeaders.has(header)) return;
      setMobileMenuOpen(header, false);
      focusTarget ||= hamburger;
    });
    if (restoreFocus) focusTarget?.focus();
  }

  function prepareMobileHeader(header) {
    const { hamburger, menu, overlay } = mobileMenuParts(header);
    if (!hamburger || !menu) return;

    const menuId = ensureId(menu, 'hob-mobile-navigation');
    hamburger.setAttribute('role', 'button');
    hamburger.setAttribute('tabindex', '0');
    hamburger.setAttribute('aria-controls', menuId);
    hamburger.setAttribute('aria-label', hamburger.getAttribute('aria-label') || 'Menu');
    hamburger.setAttribute('aria-expanded', String(menu.classList.contains('active')));
    menu.setAttribute('aria-hidden', String(!menu.classList.contains('active')));
    menu.inert = !menu.classList.contains('active');
    if (overlay) overlay.setAttribute('aria-hidden', String(!menu.classList.contains('active')));
    if (menu.classList.contains('active')) {
      hydrateMobileNavigation(menu);
      openHeaders.add(header);
    }
    else openHeaders.delete(header);
    syncScrollLock();
  }

  function disposeRoot(root) {
    elementsWithin(root, SELECTORS.header).forEach((header) => {
      const { menu } = mobileMenuParts(header);
      if (menu?.classList.contains('active') || openHeaders.has(header)) {
        setMobileMenuOpen(header, false);
      } else {
        openHeaders.delete(header);
      }
    });

    animatedElements.forEach((element) => {
      if (element !== root && !root?.contains?.(element)) return;
      const open = disclosureIsOpen(element);
      clearAnimation(element);
      finishAnimation(element, open);
    });
    syncScrollLock();
  }

  function prepareCollectionSidebar(sidebar) {
    sidebar
      .querySelectorAll(
        '.collection-category-link.active, .collection-category-link-level2.active, .collection-category-link-level3.active'
      )
      .forEach((activeLink) => {
        let parent = activeLink.closest('.collection-category-item, .collection-category-level2');
        while (parent && sidebar.contains(parent)) {
          const level = parent.matches('.collection-category-item') ? 1 : 2;
          const selector = level === 1 ? SELECTORS.firstDropdown : SELECTORS.secondDropdown;
          const dropdown = directChild(parent, selector);
          if (dropdown) {
            clearAnimation(dropdown);
            dropdown.style.display = 'block';
            setDisclosureState(parent, dropdown, level, true);
          }
          parent = parent.parentElement?.closest(
            '.collection-category-item, .collection-category-level2'
          );
        }

        if (
          activeLink.classList.contains('collection-category-link-level2') ||
          activeLink.classList.contains('collection-category-link-level3')
        ) {
          activeLink.classList.add('u_active_smenu');
        }
      });
  }

  function prepare(scope) {
    elementsWithin(scope, SELECTORS.header).forEach(prepareMobileHeader);
    elementsWithin(scope, SELECTORS.collectionSidebar).forEach(prepareCollectionSidebar);
    prepareDisclosures(scope);
  }

  function shouldPreventDisclosureNavigation(trigger) {
    if (!trigger.matches('a')) return true;
    const href = (trigger.getAttribute('href') || '').trim();
    return !href || href.startsWith('#');
  }

  function handleClick(event) {
    const cartOverlay = event.target.closest(SELECTORS.cartOverlay);
    if (cartOverlay) {
      event.stopPropagation();
      document.querySelector('.header_minicart')?.classList.remove('bls__opend-popup-header');
      document.documentElement.classList.remove('hside_opened');
      closeAllMobileMenus();
      return;
    }

    const mobileToggle = event.target.closest(
      `${SELECTORS.hamburger}, ${SELECTORS.mobileMenuOverlay}`
    );
    if (mobileToggle) {
      const header = mobileToggle.closest(SELECTORS.header);
      const { menu } = mobileMenuParts(header);
      if (menu) {
        event.preventDefault();
        setMobileMenuOpen(header, !menu.classList.contains('active'));
      }
      return;
    }

    if (event.target.closest(SELECTORS.quickAction)) {
      closeAllMobileMenus();
    }

    const backLink = event.target.closest(SELECTORS.collectionBack);
    if (backLink) {
      event.preventDefault();
      const sidebar = backLink.closest(SELECTORS.collectionSidebar);
      const submenuView = sidebar?.querySelector('.collection-menu-submenu-view');
      const fullMenuView = sidebar?.querySelector('.collection-menu-full-view');
      if (submenuView && fullMenuView) {
        submenuView.style.display = 'none';
        fullMenuView.classList.remove('collection-menu-hidden');
      }
      return;
    }

    const secondTrigger = event.target.closest(SELECTORS.secondDisclosure);
    if (secondTrigger && toggleDisclosure(secondTrigger, 2)) {
      if (shouldPreventDisclosureNavigation(secondTrigger)) event.preventDefault();
      return;
    }

    const firstTrigger = event.target.closest(SELECTORS.firstDisclosure);
    if (firstTrigger && toggleDisclosure(firstTrigger, 1)) {
      if (shouldPreventDisclosureNavigation(firstTrigger)) event.preventDefault();
    }
  }

  function handleKeydown(event) {
    if (event.key === 'Escape') {
      closeAllMobileMenus({ restoreFocus: true });
      return;
    }

    if (event.key !== 'Enter' && event.key !== ' ') return;
    const keyboardButton = event.target.closest(
      `${SELECTORS.hamburger}, .u_ficon_mb, .u_sicon_mb`
    );
    if (!keyboardButton) return;
    event.preventDefault();
    keyboardButton.click();
  }

  function listen(target, type, handler) {
    target.addEventListener(type, handler);
    removers.push(() => target.removeEventListener(type, handler));
  }

  function mount(scope = document) {
    if (!mounted) {
      listen(document, 'click', handleClick);
      listen(document, 'keydown', handleKeydown);
      listen(document, 'shopify:section:load', (event) => prepare(event.target));
      listen(document, 'shopify:section:unload', (event) => disposeRoot(event.target));
      mounted = true;
    }
    prepare(scope);
  }

  function destroy() {
    disposeRoot(document);
    removers.splice(0).forEach((remove) => remove());
    animatedElements.forEach((element) => {
      const open = disclosureIsOpen(element);
      clearAnimation(element);
      finishAnimation(element, open);
    });
    openHeaders.clear();
    syncScrollLock();
    mounted = false;
  }

  window.HobNavigation = Object.freeze({ mount, destroy });
  mount(document);
})();
